import { render } from "./UsageStatusSectionPlanCmp.vue?vue&type=template&id=4d9b877d&scoped=true"
import script from "./UsageStatusSectionPlanCmp.vue?vue&type=script&lang=js"
export * from "./UsageStatusSectionPlanCmp.vue?vue&type=script&lang=js"

import "../css/UsageStatusSectionPlan.css?vue&type=style&index=0&id=4d9b877d&scoped=true&lang=css"
import "./UsageStatusSectionPlanCmp.vue?vue&type=style&index=1&id=4d9b877d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9b877d"]])

export default __exports__